const SUPABASE_BG_BASE =
  "https://rmldtucqedoofrfcekzl.supabase.co/storage/v1/object/public/assets/background/" as const;

export const BACKGROUNDS = {
  sandy_beach: {
    path: `${SUPABASE_BG_BASE}sandy_beach.webp`,
    cutoff: 400,
    anchor: "left",
  },
  treasure_beach: {
    path: `${SUPABASE_BG_BASE}treasure_beach.webp`,
    cutoff: 600,
    anchor: "left",
  },
  forest: {
    path: `${SUPABASE_BG_BASE}forest.webp`,
    cutoff: 400,
    anchor: "center",
  },
  forest_night: {
    path: `${SUPABASE_BG_BASE}forest_night.webp`,
    cutoff: 400,
    anchor: "center",
  },
  pyramid: {
    path: `${SUPABASE_BG_BASE}pyramid.webp`,
    cutoff: 575,
    anchor: "center",
  },
  tomb: {
    path: `${SUPABASE_BG_BASE}tomb.webp`,
    cutoff: 550,
    anchor: "right",
  },
  terrace: {
    path: `${SUPABASE_BG_BASE}terrace.webp`,
    cutoff: 525,
    anchor: "center",
  },
  temple_stone: {
    path: `${SUPABASE_BG_BASE}temple_stone.webp`,
    cutoff: 530,
    anchor: "center",
  },
  desert: {
    path: `${SUPABASE_BG_BASE}desert.webp`,
    cutoff: 400,
    anchor: "center",
  },
  desert_ruins: {
    path: `${SUPABASE_BG_BASE}desert_ruins.webp`,
    cutoff: 300,
    anchor: "center",
  },
  egypt: {
    path: `${SUPABASE_BG_BASE}egypt.webp`,
    cutoff: 550,
    anchor: "center",
  },
  exoplanet: {
    path: `${SUPABASE_BG_BASE}exoplanet.webp`,
    cutoff: 500,
    anchor: "center",
  },
  field_mystic: {
    path: `${SUPABASE_BG_BASE}field_mystic.webp`,
    cutoff: 350,
    anchor: "center",
  },
  forest_plain: {
    path: `${SUPABASE_BG_BASE}forest_plain.webp`,
    cutoff: 400,
    anchor: "center",
  },
  grass_islands: {
    path: `${SUPABASE_BG_BASE}grass_islands.webp`,
    cutoff: 500,
    anchor: "center",
  },
  mushroom_forest: {
    path: `${SUPABASE_BG_BASE}mushroom_forest.webp`,
    cutoff: 350,
    anchor: "center",
  },
  ruins: {
    path: `${SUPABASE_BG_BASE}ruins.webp`,
    cutoff: 175,
    anchor: "center",
  },
  ship_deck: {
    path: `${SUPABASE_BG_BASE}ship_deck.webp`,
    cutoff: 250,
    anchor: "left",
  },
  ship_hold: {
    path: `${SUPABASE_BG_BASE}ship_hold.webp`,
    cutoff: 350,
    anchor: "center",
  },
} as const;

export type BackgroundName = keyof typeof BACKGROUNDS;
export type BackgroundConfig = (typeof BACKGROUNDS)[BackgroundName];

export const BACKGROUND_DEFAULT: BackgroundName = "forest_plain";
